import { Select } from 'antd'
import React, { useRef } from 'react'
import angle from '../../../../assets/images/angle-down.svg'
import { useStore } from '../../../../mobx-store/context'
import { checkIfDisabled, option } from './input_select'

const InputMultiselect = ({
  placeholder,
  value,
  popupContainer,
  loading,
  options,
  colorArrow,
  onChange,
  customOptions,
  selectVars,
  handleChange,
  allowClear,
  showDeprecated,
  name,
  showDeprecatedLabel,
  allowDisabled,
  onlyEnabled,
}) => {
  const store = useStore()
  const multiSelectRef = useRef()

  const mutatedOptions = options
    ?.filter(
      (item) =>
        (showDeprecated ? item.id : !item.is_deprecated) &&
        (onlyEnabled ? item.enabled : true)
    )
    ?.map((item, index) =>
      option({
        item,
        selectVars,
        index,
        disabled: !item.enabled,
        showDeprecatedLabel,
        allowDisabled,
      })
    )

  return (
    <Select
      mode='multiple'
      allowClear={allowClear}
      style={{ width: '100%' }}
      placeholder={placeholder ? placeholder : 'Select all that apply'}
      listHeight={380}
      ref={multiSelectRef}
      onChange={(value) => {
        if (value.length && value[value.length - 1] === 'all') {
          const items = options
            ?.filter(
              (item) =>
                !item.is_deprecated && !checkIfDisabled({ item, name, store })
            )
            .map((item) => item.id)
          onChange(items)
          multiSelectRef.current.blur()
        } else {
          onChange(value)
        }
        handleChange && handleChange()
      }}
      value={value || []}
      showArrow={true}
      loading={loading}
      suffixIcon={colorArrow && <img src={angle} alt={'#'} />}
      getPopupContainer={() =>
        popupContainer
          ? document.getElementById(popupContainer)
          : document.querySelector('body')
      }
      filterOption={(input, option) =>
        option.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {options?.length > 2 && (
        <Select.Option value={'all'}>Select All</Select.Option>
      )}
      {customOptions || mutatedOptions}
    </Select>
  )
}

export default InputMultiselect
